
import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';

export interface DurationDistributionChartProps {
  data: {
    name: string;
    value: number;
  }[];
}

const DurationDistributionChart: React.FC<DurationDistributionChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">
        No duration distribution data available
      </div>
    );
  }

  const colors = [
    '#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', 
    '#EC4899', '#06B6D4', '#F97316', '#6366F1', '#14B8A6'
  ];

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip 
          formatter={(value) => [value, 'Contracts']}
          labelFormatter={(label) => `Duration: ${label}`}
        />
        <Legend />
        <Bar 
          dataKey="value" 
          fill="#3B82F6" 
          name="Number of Contracts" 
          radius={[4, 4, 0, 0]}
        >
          {data.map((entry, index) => (
            <rect key={`rect-${index}`} fill={colors[index % colors.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DurationDistributionChart;
